export default __webpack_public_path__ + "images/View_of_Genitalia_dark.e758a8e5d84d4f94b11468682f3b0e73.png";